import type { AxiosError } from 'axios'

/** Format FastAPI / Axios error payloads for display. */
export function formatApiError(error: unknown, fallback = 'Request failed'): string {
  if (error && typeof error === 'object' && 'response' in error) {
    const axiosError = error as AxiosError<{ detail?: unknown }>
    const detail = axiosError.response?.data?.detail
    if (typeof detail === 'string') {
      return detail
    }
    if (Array.isArray(detail)) {
      return detail
        .map((item) => {
          if (item && typeof item === 'object' && 'msg' in item) {
            return String(item.msg)
          }
          return JSON.stringify(item)
        })
        .join('; ')
    }
    if (detail && typeof detail === 'object') {
      return JSON.stringify(detail)
    }
  }
  if (error instanceof Error) {
    return error.message
  }
  return fallback
}
